/**
 * Serviço para tradução que usará preferencialmente traduções salvas no banco de dados.
 * Criado para contemplar muiti-clientes do Obrasgov, pois atualmente existe um arquivo único de tradução para todos os clientes obrasGov.
 * @param {*} extDbTranslateConfig 
 * @param {*} $translate 
 * @returns a tradução customizada via <i>extDbTranslateConfig</i> ou na inexistência dessa a tradução default dos arquivos i18n ($translate)
 */

function extDbTranslate (extDbTranslateConfig, $translate) {
    return function (label)  {
        return extDbTranslateConfig.getExtendLabel(label) || $translate.instant(label)
    }
}

extDbTranslate.$inject = ['extDbTranslateConfig', '$translate']
export default extDbTranslate


// WEBPACK FOOTER //
// ./src/app/scripts/modules/extDbTranslate.js